import styled from "styled-components";
import { Form } from "formik";

export const PageContent = styled.div`
  padding: 24px 20px;
  display: flex;
  justify-content: center;
`;

export const FormContainer = styled(Form)`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .field-holder,
  .input-phone-container {
    margin-bottom: 0;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--color-purple, #572580);
    margin: 0 0 8px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;
